import React, { useEffect, useState } from 'react';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { InlineMath } from 'react-katex';

const QuizReportQuestion = ({
  language,
  currentQuestion,
  question,
  selectedAns,
  correctAns,
  options,
  yourAns,
  explanation,
  viewType,
  images,
}) => {
  const [showCorrectAns, setShowCorrectAns] = useState(false);
  const [showExplanation, setShowExplanation] = useState(false);
  useEffect(() => {
    setShowExplanation(false);
    setShowCorrectAns(false);
  }, [currentQuestion]);
  // console.log(correctAns, yourAns, currentQuestion, 'images');
  const iconStyle = {
    color: 'white',
    width: '14px',
    marginRight: '6px',
    marginBottom: '8px',
  };

  const renderMixedContent = (latexInput) => {
    let inputStr =
      typeof latexInput == 'string' ? latexInput : String(latexInput);
    let parts = inputStr?.split(/(\$[^$]+\$)/g);
    return parts?.map((part, index) => {
      if (part?.startsWith('$') && part?.endsWith('$')) {
        let modifiedPart = part?.replace(/\$/g, '');
        return <InlineMath key={index} math={modifiedPart} />;
      }
      return <span className={language.includes('fganh') || language.includes('हिंदी') ? 'hinditext' : ''} key={index}>{part}</span>;
    });
  };

  return (
    <div style={{ marginTop: '20px' }} className='quiz-wrapper'>
      <div
        style={{
          display: 'flex',
          width: '100%',
          justifyContent: 'space-between',
        }}
        className='quiz-header'
      >
        <div className='question-text'>Question No. {currentQuestion + 1}</div>
      </div>

      <div
        style={{
          display: 'flex',
          width: '100%',
          justifyContent: 'space-between',
        }}
      >
        <div className='quiz-description'>
          <p>{renderMixedContent(question)}</p>
          {images &&
            images.length > 0 &&
            images.filter((img) => img.imageFor === 'question').length > 0 && (
              <img
                src={`https://firebasestorage.googleapis.com/v0/b/tn-edu.appspot.com/o/${encodeURIComponent(
                  images.filter((img) => img.imageFor === 'question')[0]
                    .imagePath
                )}?alt=media`}
                alt='Question'
                className='question-image-report'
              />
            )}
        </div>
        <div style={{ fontSize: '14px' }}>
          <p style={{ marginBottom: '6px', fontSize: '14px' }}>
            Selected Ans.: {selectedAns == "Skipped" ? "Skipped" : renderMixedContent(selectedAns || 'skipped')}
          </p>

          {showCorrectAns && (
            <p style={{ marginBottom: '0', fontSize: '14px' }}>
              Correct Ans.:
              {renderMixedContent(options[correctAns - 1])}
            </p>
          )}
        </div>
      </div>

      <div className='quiz-options'>
        {options.map((option, index) => {
          const imgFor =
            index === 0
              ? 'optionA'
              : index === 1
                ? 'optionB'
                : index === 2
                  ? 'optionC'
                  : 'optionD';

          return (
            <>
              <div className='option' key={index}>
                {yourAns == index ? (
                  <RadioButtonCheckedIcon style={iconStyle} />
                ) : (
                  <RadioButtonUncheckedIcon style={iconStyle} />
                )}
                <label
                  style={{
                    color:
                      correctAns - 1 == yourAns && yourAns == index
                        ? '#00FF40'
                        : showCorrectAns && correctAns - 1 == index
                          ? '#00FF40'
                          : correctAns - 1 != yourAns && yourAns == index
                            ? 'red'
                            : 'white',
                  }}
                  htmlFor={`option${index}`}
                >
                  {renderMixedContent(option || `Loading...?`)}
                </label>
              </div>

              {images &&
                images.length > 0 &&
                images.filter((img) => img.imageFor === imgFor).length > 0 && (
                  <img
                    src={`https://firebasestorage.googleapis.com/v0/b/tn-edu.appspot.com/o/${encodeURIComponent(
                      images.filter((img) => img.imageFor === imgFor)[0]
                        .imagePath
                    )}?alt=media`}
                    alt='Question'
                    className='question-image-report'
                    style={{ marginBottom: '12px' }}
                  />
                )}
            </>
          );
        })}
      </div>

      {showExplanation && (
        <div style={{ margin: '20px 0 0 0', fontSize: '14px' }}>
          <p>
            Explanation:{' '}
            {renderMixedContent(explanation || 'No explanation available')}
          </p>
        </div>
      )}

      <div
        style={{
          display: 'flex',
          justifyContent: 'end',
          gap: '12px',
        }}
        className='quiz-buttons'
      >
        <button onClick={() => setShowCorrectAns(true)} className='btn '>
          Show Correct Ans.
        </button>

        {explanation && (
          <button onClick={() => setShowExplanation(true)} className='btn '>
            Show Explanation
          </button>
        )}
      </div>
    </div>
  );
};

export default QuizReportQuestion;
